<template>
  <div class="dialog"
         v-show="dialogVisible">
      <div class="pop-up">
        <div class="title">
          <h3>消息列表</h3>
          <em class="el-icon-close"
              @click="handleClose"></em>
        </div>
        <div class="pop-up-body" infinite-scroll-distance="0"
              infinite-scroll-immediate-check
              v-infinite-scroll="load">
          <ul class="infinite-list">
            <li v-for="item in unreads"
                :key="item.id">
              <img src="http://member.intelliquor.com/zy/msg_icon.png"
                   alt="">
              <div class="ctx">

                <div>
                  <p>{{item.topic}}</p>
                  <em>{{item.createTime}}</em>
                </div>
                <span>{{item.message}}</span>
              </div>
              <em v-if="item.isRead == 0" />
            </li>
            <div class="tieku"
                 v-if="unreads.length>0">
              <div /><span>以上为最新消息</span>
              <div />
            </div>
            <li v-for="item in reads"
                :key="item.id">
              <img src="http://member.intelliquor.com/zy/msg_icon.png"
                   alt="">
              <div class="ctx">

                <div>
                  <p>{{item.topic}}</p>
                  <em>{{item.createTime}}</em>
                </div>
                <span>{{item.message}}</span>
              </div>
            </li>
          </ul>
          <div class="empty" v-if="list.length===0">
            <img src="http://member.intelliquor.com/zy/empty_icon.png" alt="">
            <p>暂无消息～</p>
          </div>
        </div>

      </div>
      
    </div>
</template>
<script>
import { getListByPage, readAll } from '@/api/yundian.js'
export default {
  name:'appMessageDialog',
  props:{
    dialogVisible:{
      type:Boolean,
      default:false
    },
    total:{
      type:[Number,String],
      default:0
    }
  },
  watch:{
    dialogVisible:{
      handler(newValue){
        if(newValue){
          
          this.list = []
          this.page = 1
          this.getMessageList()
          
        }
      },
      immediate:true
    }
  },
  data(){
    return {
      page:1,
      list: [],
      num:0
    }
  },
  computed: {
    unreads() {
      let arr = this.list.filter((el) => el.isRead !== 1)
      let len = arr.length > 99 ? 99 : arr.length
      this.$emit('update:total',len)
      return arr
    },
    reads() {
      return this.list.filter((el) => el.isRead === 1)
    },
  },
  mounted() {
    this.getMessageList()
  },
  methods: {
    load() {
      if(this.page>=Math.ceil(this.num/15) ) return
      this.page++
      this.getMessageList()
    },
    handleClose() {
      this.$nextTick(()=>{
        this.$emit('update:total',0)
        this.$emit('update:dialogVisible',false)
      })
      
    },
    getMessageList() {
      let params = {
        page: this.page,
        limit: 15,
        companyId: Lockr.get('userInfo').id,
      }
      getListByPage(params).then((res) => {
        if (res.data.code !== 200) return this.$message.error(res.data.msg)
        // this.list=res.data.result
        this.num = res.data.total
        this.list = [...this.list,...res.data.result]
        if(this.dialogVisible){
          readAll().then((res) => {
            if (res.data.code !== 200) return this.$message.error(res.data.msg)
            
          })
        }
      })
    },
  },
}
</script>
<style scoped>
.empty{
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 60px;
}
.empty img{
  width: 248px;
  height: 176px;
}
.empty p {
  font-size: 14px;
  color: #666;
}
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  
}
.pop-up {
  position: absolute;
  width: 70%;
  left: 50%;
  top: 50px;
  height: 60%;
  transform: translateX(-50%);
  background-color: #fff;
  box-shadow: 0px 12px 48px rgba(0, 0, 0, 0.03);
  border-radius: 2px;
  overflow: hidden;
  padding-bottom: 76px;
}
.pop-up .pop-up-body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 0 0 3px 3px;
  padding: 20px 24px;
}
.pop-up .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 0 20px;
  height: 56px;
  box-sizing: border-box;
  /* margin-bottom: 20px; */
}
.pop-up .title h3 {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.pop-up em {
  color: #000;
  cursor: pointer;
}
ul {
  width: 100%;
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}
ul > li {
  width: 100%;
  height: 107px;
  background-color: #f7f8fa;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 16px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  cursor: auto;
}
ul > li:last-child {
  margin-bottom: 0;
}

ul > li > em {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff4d4f;
  position: absolute;
  top: 12px;
  right: 12px;
}
ul > .tieku {
  display: flex;
  align-items: center;
}
ul > .tieku div {
  height: 1px;
  flex: 1;
  background-color: #e3e2e2;
}
ul > .tieku span {
  font-size: 12px;
  color: #999999;
  margin: 0 8px;
}
ul > li img {
  width: 46px;
  height: 46px;
  margin-right: 16px;
}
.ctx {
  flex: 1;
  text-align: left;
}
.ctx > div {
  display: flex;
  justify-content: space-between;
  line-height: normal;
  margin-top: 15px;
}
.ctx > div p {
  padding: 0;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.ctx > div em {
  font-size: 14px;
  color: #999999;
}
.ctx > span {
  font-size: 16px;
  color: #666666;
}
</style>